import {
    getLocalStorage,
    removeLocalStorage,
    setLocalStorage
} from 'libs/utils/logic/ui/systemLogic';
import { uniq } from 'lodash';

const KEY_LIST_MAP = 'world_maps_v1';
const KEY_SINGLE_PREFIX_MAP = 'world_map_token_v1_';

const KEY_LIST_GUIDES = 'guides_v1';
const KEY_SINGLE_PREFIX_GUIDE = 'guide_token_v1_';

const tokenCache = new Map<string, string>();

export const useWorldMapLocalStorage = () => {
    const getList = (prefix: string) => {
        const listStr = getLocalStorage(prefix);
        return listStr ? uniq(listStr.split(';')) : [];
    };

    const getTokenForId = (prefix: string, mapId: string) => {
        const exists = tokenCache.has(mapId);
        if (exists) {
            return tokenCache.get(mapId);
        }

        const currentValue = getLocalStorage(prefix + mapId);
        tokenCache.set(mapId, currentValue);

        return currentValue;
    };

    const storeTokenForMapId = (mapId: string, token: string) => {
        setLocalStorage(KEY_SINGLE_PREFIX_MAP + mapId, token);

        const list = getList(KEY_LIST_MAP);
        setLocalStorage(KEY_LIST_MAP, [...list, mapId].join(';'));
    };

    const removeTokenForMapId = (mapId: string) => {
        removeLocalStorage(KEY_SINGLE_PREFIX_MAP + mapId);

        const list = getList(KEY_LIST_MAP);
        setLocalStorage(KEY_LIST_MAP, list.filter((e) => e !== mapId).join(';'));
    };

    const storeTokenForGuideId = (guideId: string, token: string) => {
        setLocalStorage(KEY_SINGLE_PREFIX_GUIDE + guideId, token);

        const list = getList(KEY_LIST_GUIDES);
        setLocalStorage(KEY_LIST_GUIDES, [...list, guideId].join(';'));
    };

    const removeTokenForGuideId = (guideId: string) => {
        removeLocalStorage(KEY_SINGLE_PREFIX_GUIDE + guideId);

        const list = getList(KEY_LIST_GUIDES);
        setLocalStorage(KEY_LIST_GUIDES, list.filter((e) => e !== guideId).join(';'));
    };

    return {
        getTokenForMapId: (id) => getTokenForId(KEY_SINGLE_PREFIX_MAP, id),
        getTokenForGuideId: (id) => getTokenForId(KEY_SINGLE_PREFIX_GUIDE, id),
        storeTokenForMapId,
        removeTokenForMapId,
        storeTokenForGuideId,
        removeTokenForGuideId,
        getListOfMaps: () => getList(KEY_LIST_MAP),
        getListOfGuides: () => getList(KEY_LIST_GUIDES)
    };
};
